module.exports = __webpack_public_path__ + "img/right.21432040.png";